/*=========================================================================================
  File Name: moduleDashboardGetters.js
  Description: Dashboard Module Getters
==========================================================================================*/
import _ from "lodash";
import constant from "@/utils/constant";

const formatCategoryIcon = (categoryProperties, isGetParsedIcon = false) => {
	if (!categoryProperties) return null;
	categoryProperties = JSON.parse(categoryProperties);
	if(isGetParsedIcon) {
		const parsedIcon = constant.CATEGORY_ICONS.find(
			categoryIcon => categoryIcon.iconContent === _.get(categoryProperties, "icon")
		) || constant.CATEGORY_ICONS[0];

		return parsedIcon.iconName || null;
	}
	return _.get(categoryProperties, "icon") || null;
};

const formatSensorData = (sensorData, currentValue = 0, accessoryName) => {
	// const currentValue = _.get(sensorData, 'current') || 0;
	let limit = _.get(sensorData, 'alert_threshold') ;
	let isOverLimit = false;
	isOverLimit = limit != null && currentValue > limit;
	if (!isOverLimit){
		limit = _.get(sensorData, 'warning_threshold') ;
		isOverLimit = limit != null && currentValue > limit;
	}
	let unit = _.get(sensorData, 'unit') || '';

	if (!sensorData.type || sensorData.type === "none") {
		return null;
	}
	if (sensorData.type === "temperature") {
		unit = "Celsius";
	}

	if (sensorData.type === "electric") {
		unit = "Hour";
	}
	unit = unit.charAt(0).toUpperCase() + unit.slice(1);

	const result = {
		unit,
		limit,
		value: currentValue,
		alertThreshold:  _.get(sensorData, 'alert_threshold') || null,
		warningThreshold: _.get(sensorData, 'warning_threshold') || null,
		type: sensorData.type,
		isOverLimit: isOverLimit,
		name: _.get(sensorData, 'name') || '',
		isActive: _.get(sensorData, 'is_active') || false,
		updatedAt: _.get(sensorData, "updated_at") || null,
	};
	if(accessoryName) {
		result.accessoryName = accessoryName;
	}

	return result;
};

export default {
	getDevice: (state, getters) => deviceId => getters.getParsedDevices.find(device => device.id === deviceId),
	getParsedDevices: state =>
		state.devices.map(device => ({
			...device,
			imageSource: _.get(device, "image.path") || "",
			managerName: (_.get(device, "manage_employees.data") || []).map(user => user.display_name).join(", "),
			categoryIcon: formatCategoryIcon(_.get(device, "category.properties"), true),
			statusName:
				_.get(
					_.find(state.devicesStatus, ["id", device.status]) || {},
					"name"
				) || "",
			statusColor:
				_.get(
					_.find(state.devicesStatus, ["id", device.status]) || {},
					"color"
				) || "",
			sensorData: device.accessories.map(
				accessory => accessory.sensors && accessory.sensors.length
					? formatSensorData(accessory.sensors[0], accessory.sensors[0].current, accessory.name)
					: null).filter(sensor => !_.isEmpty(sensor)),
			sensorDataUpdatedAt: _.get(device, "sensorDataUpdatedAt") || ""
		})),
	getParsedSensorAlerts: state =>
		state.sensorAlerts.map(sensorAlert => ({
			...sensorAlert,
			statusColor:
				_.get(
					_.find(state.devicesStatus, ["id", _.get(sensorAlert, "device.status")]) || {},
					"color"
				) || "",
			categoryIcon: formatCategoryIcon(_.get(sensorAlert, "device.category.properties"), true),
			sensorData: !_.isEmpty(sensorAlert.sensor) ? formatSensorData({ ...sensorAlert.sensor, updated_at: sensorAlert.updated_at }, sensorAlert.current_value) : null,
		})),
	getParsedCategories: state =>
		state.categories.map(category => ({
			...category,
			categoryIcon: formatCategoryIcon(_.get(category, "properties"), true)
		})),
};
